import { HEX_FIELD } from './fieldGeometry'
import { hexWaveFrame } from './hexWave'
import s from './visuals.module.css'

const elements = new WeakMap<SVGSVGElement, { wires: SVGLineElement[]; rails: SVGLineElement[]; joints: SVGCircleElement[] }>()
export function drawRipple(element: SVGSVGElement, elapsed: number) {
  let cached = elements.get(element)
  if (!cached) {
    cached = { wires: [...element.querySelectorAll<SVGLineElement>('[data-wire]')], rails: [...element.querySelectorAll<SVGLineElement>('[data-rail]')], joints: [...element.querySelectorAll<SVGCircleElement>('[data-joint]')] }
    elements.set(element, cached)
  }
  const points = hexWaveFrame(elapsed)
  HEX_FIELD.edges.forEach(([left, right], index) => {
    const start = points[left], end = points[right]
    const dx = end.x - start.x, dy = end.y - start.y, length = Math.hypot(dx, dy) || 1
    const opacity = (start.opacity + end.opacity) / 2
    for (const line of [cached.wires[index], cached.rails[index]]) {
      line.setAttribute('x1', (start.x + dx / length * start.radius).toFixed(2))
      line.setAttribute('y1', (start.y + dy / length * start.radius).toFixed(2))
      line.setAttribute('x2', (end.x - dx / length * end.radius).toFixed(2))
      line.setAttribute('y2', (end.y - dy / length * end.radius).toFixed(2))
      line.setAttribute('opacity', opacity.toFixed(3))
    }
  })
  points.forEach((point, index) => {
    const joint = cached.joints[index]
    joint.setAttribute('cx', point.x.toFixed(2))
    joint.setAttribute('cy', point.y.toFixed(2))
    joint.setAttribute('r', point.radius.toFixed(2))
    joint.setAttribute('opacity', point.opacity.toFixed(3))
  })
}

/** The same hex net responds as a continuous surface; no hard circular crop. */
export function HexRipple({ className }: { className?: string }) {
  return <svg data-arrival-grid preserveAspectRatio="xMidYMid slice" className={`${s.hexRipple} ${className ?? ''}`.trim()} viewBox="0 0 720 520" aria-hidden="true" focusable="false">
    <g className={s.waveRails}>{HEX_FIELD.edges.map(([left, right], index) => <line key={index} data-rail x1={HEX_FIELD.vertices[left].x} y1={HEX_FIELD.vertices[left].y} x2={HEX_FIELD.vertices[right].x} y2={HEX_FIELD.vertices[right].y} opacity="0" />)}</g>
    <g className={s.waveWires}>{HEX_FIELD.edges.map(([left, right], index) => <line key={index} data-wire x1={HEX_FIELD.vertices[left].x} y1={HEX_FIELD.vertices[left].y} x2={HEX_FIELD.vertices[right].x} y2={HEX_FIELD.vertices[right].y} opacity="0" />)}</g>
    <g className={s.waveJoints}>{HEX_FIELD.vertices.map((point, index) => <circle key={index} data-joint cx={point.x} cy={point.y} r="2" opacity="0" />)}</g>
  </svg>
}
